import { Box,Button } from "@mui/material"
import { deleteCoords } from "../supabaseApi"

const DeletionPrompt=({
                        authData,
                        fetchData,
                        mapRef,
                        itemToDelete,
                        handleItemToDelete,
                        handleItemsToeEdit,
                        handleMarkedThumbnail,
                        handleRightPanel,
                        handleItemsToMark,
                        handleDeletionPromptOpen
                    })=>{

    return <Box sx={{position:'absolute',
                    bottom: '350px',
                    left: '100px', 
                    width:'200px',
                    zIndex:3,
                    backgroundColor:'white',
                    padding:'20px',
                    direction:'rtl'}}>

        <form onSubmit={async (e)=>{
            e.preventDefault();
            await deleteCoords(itemToDelete.id).catch(err=>console.log(err))
            handleRightPanel(0)
            handleItemsToeEdit([])
            handleItemsToMark([])
            handleDeletionPromptOpen()
            fetchData(mapRef.getBounds())
            handleItemToDelete(null)
            handleMarkedThumbnail(null)
        }
    }>
   
        <span style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
        <Button  type="submit">Confirm</Button>
        
        <Button onClick={()=>{
            handleDeletionPromptOpen()
            handleItemToDelete(null)
        }}>Cancel</Button>

        </span>
    </form>
    </Box>
}

export default DeletionPrompt